import React from "react";
import actingImg from '../../assets/images/resources/about-one-img-1.jpg';

const ActingMain = () => {
  return (
    <section className="min-h-screen pb-10 bg-white">

      {/* Main Content */}
      <div className="container max-w-6xl px-4 mx-auto mt-8">
        <div className="flex flex-col items-center gap-8 md:flex-row md:items-start">
          {/* Left: Course Image */}
          <div className="w-full md:w-1/2" data-aos="fade-right">
            <img src="https://sunrisingcinevisionacademy.com/public/assets/images/acting-technique.jpg" alt="Acting Technique" className="w-full h-auto rounded-lg shadow-lg" />
          </div>
          {/* Right: Course Intro */}
          <div className="w-full p-2 md:w-1/2" data-aos="fade-left">
            <h2 className="text-2xl font-bold mb-2 text-[#A14D1F]">Master the Art of Acting with Sunrising Cinevision Academy</h2>
            <p className="mb-4 text-gray-700">
              Sunrising Cinevision Academy, a premier acting school, offers an extensive acting course designed to transform aspiring performers into skilled professionals. Our acting classes provide hands-on training in diverse acting techniques, from classical methods to modern on-screen performance. With guidance from industry experts and renowned celebrities, students gain the expertise and confidence needed to thrive in film, television, and theatre.
            </p>
            <h2 className="text-xl font-bold mb-2 text-[#A14D1F]">What You Will Learn</h2>
            <ul className="pl-5 mb-2 space-y-1 text-gray-700 list-disc">
              <li>Fundamental acting techniques, including Method, Meisner, and Stanislavski</li>
              <li>Character development, scene study, and improvisation</li>
              <li>Camera acting, audition techniques, and voice modulation</li>
              <li>Film and television acting, Shakespearean performance, and physical theater</li>
              <li>Business of acting, industry networking, and career management</li>
            </ul>
          </div>
        </div>

        {/* Course Modules */}
        <div className="grid grid-cols-1 gap-6 mt-10 md:grid-cols-2">
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-right">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Foundational Courses:</h3>
            <ol className="pl-5 space-y-1 text-gray-700 list-decimal">
              <li>Introduction to Acting</li>
              <li>Acting Techniques (Method, Meisner, Stanislavski)</li>
              <li>Scene Study</li>
              <li>Character Development</li>
              <li>Improvisation</li>
            </ol>
          </div>
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-left">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Intermediate Courses:</h3>
            <ol className="pl-5 space-y-1 text-gray-700 list-decimal">
              <li>Script Analysis</li>
              <li>Audition Techniques</li>
              <li>Camera Acting</li>
              <li>Voice and Movement</li>
              <li>Physical Theater</li>
            </ol>
          </div>
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-right">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Advanced Courses:</h3>
            <ol className="pl-5 space-y-1 text-gray-700 list-decimal">
              <li>Advanced Scene Study</li>
              <li>Shakespearean Acting</li>
              <li>Film and Television Acting</li>
              <li>Directing for Actors</li>
              <li>Business of Acting</li>
            </ol>
          </div>
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-left">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Specialized Courses:</h3>
            <ol className="pl-5 space-y-1 text-gray-700 list-decimal">
              <li>Comedy Acting</li>
              <li>Dramatic Acting</li>
              <li>Action and Stunt Acting</li>
              <li>Voice-Over Acting</li>
              <li>Screenwriting for Actors</li>
            </ol>
          </div>
        </div>

        {/* Instructors & More */}
        <div className="p-10 mt-10 bg-white shadow-md rounded-xl">
          <h2 className="text-3xl font-bold text-center mb-10 text-[#A14D1F]">Learn from the Best</h2>
          <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
            <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
              <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Celebrity Instructors (Acting):</h3>
              <ul className="pl-5 space-y-1 text-gray-700 list-disc">
                <li>Anupam Kher</li>
                <li>Naseeruddin Shah</li>
                <li>Vidya Balan</li>
                <li>Manoj Bajpayee</li>
                <li>Rajkummar Rao</li>
              </ul>
            </div>
            <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
              <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Celebrity Instructors (Directing):</h3>
              <ul className="pl-5 space-y-1 text-gray-700 list-disc">
                <li>Rajkumar Hirani</li>
                <li>Anurag Kashyap</li>
                <li>Shoojit Sircar</li>
                <li>Gauri Shinde</li>
                <li>Imtiaz Ali</li>
              </ul>
            </div>
            <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
              <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Guest Lecturers:</h3>
              <ul className="pl-5 space-y-1 text-gray-700 list-disc">
                <li>Amitabh Bachchan</li>
                <li>Shah Rukh Khan</li>
                <li>Aamir Khan</li>
                <li>Priyanka Chopra</li>
                <li>Irrfan Khan (Late Actor and Legend)</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Partnerships, Alumni, Certifications, Scholarships, Duration, Outcomes */}
        <div className="grid grid-cols-1 gap-6 mt-10 md:grid-cols-2">
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Industry Partnerships</h3>
            <ul className="pl-5 space-y-1 text-gray-700 list-disc">
              <li>Yash Raj Films</li>
              <li>Dharma Productions</li>
              <li>Reliance Entertainment</li>
              <li>Excel Entertainment</li>
              <li>Sony Pictures Networks</li>
            </ul>
          </div>
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Alumni Network</h3>
            <ul className="pl-5 space-y-1 text-gray-700 list-disc">
              <li>Connect with successful alumni in film, television, and theater.</li>
              <li>Participate in mentorship programs.</li>
              <li>Access job placement opportunities.</li>
            </ul>
          </div>
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Certifications Offered</h3>
            <ul className="pl-5 space-y-1 text-gray-700 list-disc">
              <li>Diploma in Acting</li>
              <li>Certificate in Acting</li>
              <li>Advanced Certificate in Acting</li>
            </ul>
          </div>
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Scholarship Opportunities</h3>
            <ul className="pl-5 space-y-1 text-gray-700 list-disc">
              <li>Merit-based scholarships</li>
              <li>Need-based scholarships</li>
              <li>Talent-based scholarships</li>
            </ul>
          </div>
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Course Duration</h3>
            <ul className="pl-5 space-y-1 text-gray-700 list-disc">
              <li>Certification Course in Acting – 4 months</li>
              <li>Certification Course in Acting – 6 months</li>
              <li>Diploma Course in Acting – 12 months</li>
            </ul>
          </div>
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Key Learning Outcomes</h3>
            <ul className="pl-5 space-y-1 text-gray-700 list-disc">
              <li>Develop essential acting techniques for stage and screen.</li>
              <li>Master voice modulation, movement, and emotional expression.</li>
              <li>Learn on-camera acting, audition strategies, and industry insight.</li>
              <li>Understand the business aspects of acting and career-building strategies.</li>
              <li>Gain hands-on experience with expert mentorship and industry exposure.</li>
            </ul>
          </div>
        </div>

        {/* Call to Action */}
        <div className="p-8 mt-10 text-center bg-white shadow-md rounded-xl" data-aos="fade-up">
          <h3 className="uppercase tracking-wide text-lg font-bold mb-4 text-[#A14D1F]">Start Your Acting Journey Today!</h3>
          <p className="mb-6 text-gray-700">Enroll in the acting course at Sunrising Cinevision Academy and take your first step toward becoming a successful actor.</p>
          <a href="/admission" className="inline-block px-8 py-3 text-lg font-bold text-white bg-gradient-to-r from-[#A14D1F] via-[#A14D1F] to-[#4A2F24] rounded-2xl shadow-lg hover:scale-105 transition-transform">Apply Now</a>
        </div>
      </div>
    </section>
  );
};

export default ActingMain;
